export enum MasterAccountExpirationMode {
	NEVER_EXPIRE = 'neverExpire',
	EXPIRE_ON_DATE = 'expireOnDate'
}